var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6138_34590)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32044 5.17523H3.00011C1.89505 5.17523 1 6.12428 1 7.29334V17.8819C1 19.052 1.89505 20 3.00011 20H14.0007C15.1057 20 16.0008 19.052 16.0008 17.8819V10.1315L12.0866 14.2757C11.7448 14.6412 11.2996 14.8938 10.8105 14.9998L8.12938 15.5678C6.37929 15.9378 4.8372 14.3047 5.18722 12.4526L5.72325 9.61347C5.82026 9.10144 6.05827 8.63042 6.40729 8.2614L9.32044 5.17523Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8469 3.31711C17.7458 3.06113 17.5975 2.82639 17.4099 2.62508C17.2253 2.42819 17.0028 2.27069 16.7558 2.16205C16.5125 2.05518 16.2496 2 15.9838 2C15.718 2 15.4551 2.05518 15.2117 2.16205C14.9647 2.27069 14.7422 2.42819 14.5577 2.62508L14.0117 3.20311L16.8638 6.22327L17.4099 5.64424C17.5995 5.44445 17.748 5.20931 17.8469 4.9522C18.0529 4.42664 18.0529 3.84267 17.8469 3.31711ZM15.4508 7.72035L12.5976 4.69919L7.82035 9.75946C7.74986 9.83455 7.70233 9.92824 7.68334 10.0295L7.14731 12.8696C7.07731 13.2396 7.38632 13.5657 7.73534 13.4917L10.4175 12.9246C10.5151 12.9029 10.6039 12.8524 10.6725 12.7796L15.4508 7.72035Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6138_34590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditblack);
export default __webpack_public_path__ + "static/media/editblack.1371075525dc42e62977fdd5d16d38fc.svg";
export { ForwardRef as ReactComponent };